import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useProjectElementListStore } from '../../shared/store/projectElementStore';
import { DisplayAlignment, DisplaySize, DeviceType, ImageStyle, PEInfoType, TextAlignment } from '../../shared/enum/EnumRepository';
import { DocumentData } from '../../shared/dto/EntityRepository';
import { ImgContentInfoWrapper, isCenterVisible } from './WorkInfo';
import { InputPEDetailInfo } from '../../shared/component/headless/input/InputBody';
import MoleculeInputDiv from '../../shared/component/molecule/MoleculeInputDiv';
import { useDeviceStore } from '../../shared/store/deviceStore';
import { DOCUMENT_DESCRIPTION_MAX_LENGTH } from '../../shared/constants/limits';

export interface DocumentInfoProps {
  peId: string;
  alignment: DisplayAlignment;
  displaySize: DisplaySize;
  imageStyle: ImageStyle;
  infoType: PEInfoType;
  data: DocumentData;
}

const DocumentInfo: React.FC<DocumentInfoProps> = ({ peId, alignment, displaySize, imageStyle, infoType, data }) => {
  const handleChange = useProjectElementListStore((s) => s.updateDocument);
  const { deviceType } = useDeviceStore();

  const centerVisible = useMemo(
    () => isCenterVisible(alignment, displaySize, imageStyle, infoType),
    [alignment, displaySize, imageStyle, infoType]
  );

  if (infoType === PEInfoType.NONE) return null;

  return (
    <ImgContentInfoWrapper $centerVisible={centerVisible}>
      <TitleInfoWrpper
        $displayAlignment={alignment || DisplayAlignment.CENTER}
        $displaySize={displaySize || DisplaySize.BIG}
        $imageStyle={imageStyle || ImageStyle.LANDSCAPE}
        $isMobile={deviceType === DeviceType.MOBILE}>
        <MoleculeInputDiv
          value={data.description}
          placeholder={"Add context for this project-related image."}
          handleChange={(e) => handleChange(peId, { description: e.target.value })}
          inputStyle={InputPEDetailInfo}
          StyledDiv={Description}
          alignment={TextAlignment.CENTER}
          maxLength={DOCUMENT_DESCRIPTION_MAX_LENGTH}
        />
      </TitleInfoWrpper>
    </ImgContentInfoWrapper>
  );
};

const TitleInfoWrpper = styled.div<{
  $displayAlignment: DisplayAlignment,
  $displaySize: DisplaySize,
  $imageStyle: ImageStyle,
  $isMobile: boolean
}>`
  width: ${({ $isMobile }) => $isMobile ? '80%' : '50%'};
  height: ${({ $displayAlignment, $displaySize, $imageStyle }) =>
    $displayAlignment === DisplayAlignment.CENTER ||
      ($displaySize === DisplaySize.WIDE && $imageStyle === ImageStyle.LANDSCAPE)
      ? 'fit-content' : '0vh'};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  transition: height 0.6s ease;
`

const Description = styled.div`
  width: 100%;
  color: ${({ theme }) => theme.colors.color_Gray_04};
  text-align: center;
  ${({ theme }) => theme.typography.Body_04};
`;

export default DocumentInfo;
